<div class="deleteConfirmation" style="float: left;">
    <div *ngIf="!isActivate" >
        <button type="button"  title="Activate" (click)="startActivate()"><span class="bi bi-check-lg"></span></button>
    </div>
    <div *ngIf="isActivate">Activate?
    <button type="button" title="Confirm Activation" (click)="confirm()">Yes</button>
    <button type="button"  title="Cancel Activation" (click)="cancel()" style="width:35px">No</button>
    </div>
    </div>
